import * as Yup from "yup";

export const NorwegianPhoneNumberSchema = Yup.string().matches(
  /^(0|\+47)?[2-9]\d{7}$/,
  "Dette er ikke et norskt mobilnummer"
);
